export default {
  createOrderBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '4rem',
  },
  addRowBtn: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-start',
    flexDirection: 'column',
    margin: '1rem 0 0 0.2rem',
  },
  textStrong: {
    lineHeight: '1.6rem',
    marginBottom: '.5rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    fontSize: '1.5rem',
  },

  tableCaption: {
    padding: '0 2px',
    textAlign: 'start',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  tableCaptionMultiLine: {
    padding: '0 2px',
    textAlign: 'start',
    overflow: 'hidden',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },

  tableCell: {
    padding: '0 2px',
  },

  tableAmountCell: {
    padding: '0 2px',
    lineHeight: '5rem',
    textAlign: 'right',
  },

  table: {
    padding: 0,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    fontSize: '1rem',
  },

  innerTable: {
    margins: 0,
    paddingLeft: '8px',
    paddingRight: '1rem',
  },

  innerTableCell: {
    padding: '0 0 0 2px',
    margins: 0,
  },
}
